import SendNotification from "@/services/sendNotification";
import config from "@/assets/_config.json";

export default {
  data() {
    return {
      config
    };
  },
  methods: {
    sendFormOnBoardAuthorPublisherSubmitted(userIds, templateData) {
      const template = this.getTemplate(
        "form",
        "form_author_publisher_submitted"
      );

      if (template) {
        const commTypes = ["email"];
        return SendNotification(
          template.subject,
          userIds,
          commTypes,
          templateData,
          template.from,
          template.id,
          template.type,
          true
        )
          .then(res => {
            this.isLoading = false;
            console.log("sent successfully", res);

            this.$store.dispatch("user/showNotification", {
              title: "Email Sent",
              description: "Please check your mail for an email",
              variant: "success"
            });
          })
          .catch(error => {
            console.log("Not sent Notification");
            this.isLoading = false;
            this.$store.dispatch("user/showNotification", {
              title: error,
              description: error.message,
              variant: "danger"
            });
          });
      }
      return "error";
    },
    getTemplate(section, type) {
      const mailSection =
        this.config &&
        this.config.mail &&
        this.config.mail &&
        Array.isArray(this.config.mail)
          ? this.config.mail.filter(aMail => {
              return aMail.type === section;
            })[0]
          : null;

      const template =
        mailSection && mailSection.tpls && Array.isArray(mailSection.tpls)
          ? mailSection.tpls.filter(aTemplate => {
              return aTemplate.type === type;
            })[0]
          : null;

      template.from = mailSection.from ? mailSection.from : "hi";

      return template;
    }
  }
};
